import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={39.208}
      height={29.221}
      viewBox="0 0 39.208 29.221"
      {...props}
    >
      <g data-name="Group 515">
        <path
          data-name="Path 10857"
          d="M0 8.817a1.968 1.968 0 001.965 1.965h35.278a1.968 1.968 0 001.965-1.965V0H0zm7.907-5.444h14.959a1.172 1.172 0 010 2.343H7.907a1.172 1.172 0 010-2.343zm-5.226 0h.624a1.172 1.172 0 010 2.343h-.624a1.172 1.172 0 010-2.343z"
        />
        <path
          data-name="Path 10859"
          d="M4.121 14.844a1.722 1.722 0 001.721 1.72h27.525a1.722 1.722 0 001.721-1.72v-1.72H4.121z"
        />
        <path
          data-name="Path 10860"
          d="M6.903 18.909h25.4a1.6 1.6 0 011.6 1.6v.246a1.6 1.6 0 01-1.6 1.6h-25.4a1.6 1.6 0 01-1.6-1.6v-.246a1.6 1.6 0 011.6-1.6z"
        />
        <path
          data-name="Path 10861"
          d="M15.423 29.217h8.363a6.5 6.5 0 006.207-4.528H9.216a6.505 6.505 0 006.207 4.528z"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
